import { render, staticRenderFns } from "./CategoryThumbnail.vue?vue&type=template&id=21e998b5&scoped=true&"
import script from "./CategoryThumbnail.vue?vue&type=script&lang=js&"
export * from "./CategoryThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./CategoryThumbnail.vue?vue&type=style&index=0&id=21e998b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e998b5",
  null
  
)

export default component.exports